import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="flex min-h-[60vh] flex-col items-center justify-center rounded-2xl border border-border bg-brema-card p-10 text-center"
        >
          <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brema-red/20 text-brema-red">
            <AlertTriangle className="h-7 w-7" />
          </span>
          <h2 className="text-2xl font-semibold tracking-tight text-foreground">Qualcosa è andato storto</h2>
          <p className="mt-2 max-w-md text-muted-foreground">
            Si è verificato un problema nel caricamento di questa sezione. Puoi riprovare senza chiudere l'applicazione.
          </p>
          <button
            onClick={this.handleReset}
            data-testid="error-boundary-retry"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-colors duration-200 hover:bg-primary/90"
          >
            <RotateCcw className="h-4 w-4" /> Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
